export const experiences = [
	{
		place: "Academia Sinica",
		url: "https://homepage.iis.sinica.edu.tw/pages/lwku/index_en.html",
		title: "Part-time Research Assistant (Prof. Ku, Lun-Wei)",
		date: "Jun. '22 - Present",
		detail: [
			"Building an ice skating data collection system that consists of a line chat bot, website user interface and backend server",
			"Designing and modifying existing 3D human pose estimation model for ice skating poses",
			"Creating action recognition models for classifying ice-skating postures",
			"Developing a Natural Language Programming models for auto text generation of posture mistakes in ice skating",
		],
	},
	{
		place: "Eureka Fintech Limited",
		url: "https://www.linkedin.com/company/eureka-fintech/about/",
		title: "Engineering Consultant",
		date: "Sept. '19 - Present",
		detail: [
			"Designed and maintaining companies and employee relationship data using Neo4j graph database",
			"Built an interactive & dynamic force-directed graphs with D3.js library to show companies and employee data",
			"Created python scripts using scrappy to scrape public data of individual companies, person information as well as their news",
		]
	},
	{
		place: "Fun AI Summer Camp (Google Sponsored)",
		url: "http://mislab.cs.nthu.edu.tw/explorecsr.html",
		title: "Website Chair & Teaching Assistant",
		date: "Jan '22 - Feb '22",
		detail: [
			"Designed Google Research sponsored AI camp website",
			"Taught college and high school student about Reinforcement Learning."
		]
	},
	{
		place: "Giant Bicycle Project",
		url: "https://www.giant-bicycles.com/global",
		title: "Researcher (Client-Sponsored Capstone Project)",
		date: "Sept. '21 - Dec. '21",
		detail: [
			"Experiment with different existing 3D human pose estimation model for biking",
			"Developed a 3D human pose estimation model for predicting biker's posture using a single camera"],
	},
	{
		place: "IEEE AIVR",
		url: "https://ieee-aivr.cs.nthu.edu.tw",
		title: "Website Co-Chair",
		date: "Feb. '21 - Dec. '21",
		detail: [
			"Designed IEEE AIVR Website using react.js",
			"Deployed the website using nginx and NodeJS"
		],
	},
	{
		place: "now-ai",
		url: "https://www.linkedin.com/company/now-ai/",
		title: "Part-time software engineer",
		date: "Oct. '20 - Jan. '22",
		detail: [
			"Developed a Bidirectional Encoder Representations from Transformers (BERT) AI that summarize categorize news articles",
			"Created APIs for Microsoft team to implement our functionality in Microsoft Teams application",
			"Coded website interface using ReactJS",
			"Deployed and maintained cloud infrastructure on Google cloud"
		],
	},
	{
		place: "Industrial Technology Research Institute",
		url: "https://www.itri.org.tw/english/",
		title: "Researcher (Client-Sponsored Capstone Project)",
		date: "Oct. '20 - Jan. '21",
		detail: ["Developed a website for sports analysis using self-recorded videos", 
		"Investigated on 2D and 3D human pose estimation from a single RGB camera",
		"Used VICON, a motion capture device, for 3D posture data collection"],
	},
	{
		place: "Kerry Logistics- Hong Kong",
		url: "https://www.kerrylogistics.com/en/network/greater-china/hong-kong/",
		title: "Front-end Engineer (Client-Sponsored Capstone Project)",
		date: "Feb. '18 - May. '18",
		detail: ["Build an Optical Character Recognition (OCR) system that assigns incoming cargo boxes to correct destinations"],
	},
	{
		place: "Taiwan Semiconductor Manufacturing Company Limited (TSMC)",
		url: "https://www.tsmc.com/english",
		title: "Big Data and Aanalytics Internship",
		date: "Jun. '17 - Aug. '17",
		detail: ["Identified IR drop hotspot in board design before manufacturing", 
		"Used Python sklearn to build a clusterwise regression model to improve tail error for TSMC's static IR drop system"],
	},
];